import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { passwordError, PASSWORD_HINT } from "../lib/passwordPolicy";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const API_BASE = process.env.REACT_APP_API_URL || "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    const pwError = passwordError(password);
    if (pwError) {
      return setError(pwError);
    }
    if (password !== confirmPassword) {
      return setError("Passwords do not match");
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(data.message);
        setTimeout(() => navigate("/login"), 3000);
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError("Failed to connect to the server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <SiteHeader />
      <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>New Password</h1>
        <p style={styles.subtitle}>Enter your new password below</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="password"
            placeholder="New Password"
            style={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Confirm Password"
            style={styles.input}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <p style={styles.hint}>{PASSWORD_HINT}</p>

          {message && <p style={styles.success}>{message}</p>}
          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>

        <div style={styles.footer}>
          <Link to="/login" style={styles.link}>Back to Login</Link>
        </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}

const styles = {
  // Same shell as every other public page: sticky SiteHeader, content that
  // grows, SiteFooter pinned to the bottom.
  page: {
    minHeight: "100vh", display: "flex", flexDirection: "column",
    background: "#F4F4F0",
  },
  container: {
    display: "flex", alignItems: "center", justifyContent: "center",
    flex: 1, padding: "32px 20px", fontFamily: "'JetBrains Mono', monospace"
  },
  card: {
    background: "white", padding: "40px", borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.05)", width: "100%", maxWidth: "400px",
    textAlign: "center"
  },
  title: { fontSize: "24px", fontWeight: "700", marginBottom: "8px" },
  subtitle: { fontSize: "14px", color: "#666", marginBottom: "32px" },
  form: { display: "flex", flexDirection: "column", gap: "16px" },
  input: {
    padding: "12px", borderRadius: "8px", border: "1px solid #ddd",
    fontSize: "14px", outline: "none", fontFamily: "inherit"
  },
  button: {
    padding: "12px", borderRadius: "8px", border: "none",
    background: "#7c6af7", color: "white", fontWeight: "700",
    cursor: "pointer", fontSize: "14px", marginTop: "8px"
  },
  error: { color: "#ff4d4d", fontSize: "12px", margin: "0" },
  success: { color: "#28a745", fontSize: "12px", margin: "0" },
  hint: { fontSize: "11.5px", color: "#888", margin: "-8px 0 0 0", textAlign: "left", lineHeight: 1.45 },
  footer: { marginTop: "24px" },
  link: { color: "#7c6af7", fontSize: "12px", textDecoration: "none" }
};
